import { FeesPaidByEnum } from '../enums';

export class SaleDataUserTicketItemInterface {
  feePercentage?: number;
  feePerObject?: number;
  feePerTicketGross?: number;
  payoutPerTicketGross?: number;
  feesPaidBy?: FeesPaidByEnum;
  numberOfTickets?: number;
  pricePerTicket?: number;
  total?: number;
  payoutTotalGross?: number;
}

export interface SaleDataUserTicketResponseInterface {
  items?: SaleDataUserTicketItemInterface[];
  grossRevenue?: number;
  platformFeesTotal?: number;
  netPayoutAfterFees?: number;
}
